module.exports = __webpack_public_path__ + "img/switzerland-diabetes-mellitus-male.1e9da38b.png";